var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadNotCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 107,
    viewBox: "0 0 116 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7308_307187)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.8477,
    width: 84,
    height: 84,
    rx: 42,
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8477 42C39.8477 32.064 47.8937 24 57.8297 24C67.7837 24 75.8477 32.064 75.8477 42C75.8477 51.936 67.7837 60 57.8297 60C47.8937 60 39.8477 51.936 39.8477 42ZM51.8477 39C53.0903 39 54.0977 37.9926 54.0977 36.75C54.0977 35.5074 53.0903 34.5 51.8477 34.5C50.605 34.5 49.5977 35.5074 49.5977 36.75C49.5977 37.9926 50.605 39 51.8477 39ZM63.8477 39C65.0903 39 66.0977 37.9926 66.0977 36.75C66.0977 35.5074 65.0903 34.5 63.8477 34.5C62.605 34.5 61.5977 35.5074 61.5977 36.75C61.5977 37.9926 62.605 39 63.8477 39ZM57.8477 57.75C49.1458 57.75 42.0977 50.7019 42.0977 42C42.0977 33.2981 49.1458 26.25 57.8477 26.25C66.5495 26.25 73.5977 33.2981 73.5977 42C73.5977 50.7019 66.5495 57.75 57.8477 57.75ZM49.5977 51.75C50.8867 48.2357 54.0933 45.75 57.8477 45.75C61.6021 45.75 64.8086 48.2357 66.0977 51.75H63.4067C62.2788 49.71 60.8477 48 57.8477 48C54.8477 48 53.4004 49.71 52.2886 51.75H49.5977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.09766,
    y: 68,
    width: 105.5,
    height: 30.5,
    rx: 15.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6816 77.2227C25.2949 77.209 26.5459 78.1455 26.8125 79.5195H29.2051V76.6621H30.5039V83.2383H29.2051V80.5859H26.8193C26.5664 81.9941 25.3086 82.9375 23.6816 82.9375C21.8086 82.9375 20.4619 81.7549 20.4687 80.0664C20.4619 78.3984 21.8086 77.209 23.6816 77.2227ZM21.7129 80.0664C21.7061 81.1123 22.5264 81.8437 23.6816 81.8437C24.8164 81.8437 25.623 81.1123 25.623 80.0664C25.623 79.0137 24.8164 78.2959 23.6816 78.3027C22.5264 78.2959 21.7061 79.0137 21.7129 80.0664ZM22.5195 88.7617V83.8262H23.8047V85.248H29.2051V83.8262H30.5039V88.7617H22.5195ZM23.8047 87.6953H29.2051V86.2734H23.8047V87.6953ZM43.6016 86.3555V87.4492H32.3906V86.3555H37.3262V84.209H33.7578V80.3125H40.9492V78.5898H33.7305V77.5234H42.2344V81.3516H35.043V83.1426H42.5215V84.209H38.6113V86.3555H43.6016ZM54.416 82.4727V83.5391H45.8848V77.7559H54.3066V78.8223H47.1699V82.4727H54.416ZM44.4902 87.2988V86.2187H55.7012V87.2988H44.4902ZM66.4336 77.8379V85.8906H60.6914V77.8379H66.4336ZM61.9766 84.8379H65.1758V78.8633H61.9766V84.8379ZM68.8535 88.9395V76.6621H70.1523V88.9395H68.8535ZM76.6465 79.2187C76.6465 80.8047 77.8154 82.2949 79.709 82.8965L79.0391 83.9082C77.6309 83.4434 76.5713 82.4795 76.0107 81.2559C75.4639 82.5889 74.3701 83.6416 72.9141 84.1543L72.2441 83.1289C74.1514 82.4795 75.3271 80.8936 75.334 79.2187V78.6855H72.5859V77.6328H79.3398V78.6855H76.6465V79.2187ZM74.2539 88.6523V84.7695H75.5664V87.5996H82.6348V88.6523H74.2539ZM80.9668 85.6172V76.6758H82.2656V85.6172H80.9668ZM94.6523 76.6621V84.3867H93.4219V80.9687H92V83.9629H90.7832V76.8945H92V79.9023H93.4219V76.6621H94.6523ZM84.1387 79.082V78.0566H86.6133V76.7578H87.8984V78.0566H90.332V79.082H84.1387ZM84.6172 81.7617C84.6172 80.4902 85.7109 79.6562 87.2422 79.6562C88.8076 79.6562 89.8945 80.4902 89.8945 81.7617C89.8945 83.0332 88.8076 83.8672 87.2422 83.8672C85.7109 83.8672 84.6172 83.0332 84.6172 81.7617ZM85.7793 81.7617C85.7793 82.459 86.374 82.917 87.2422 82.9238C88.124 82.917 88.7256 82.459 88.7188 81.7617C88.7256 81.0645 88.124 80.6064 87.2422 80.6133C86.374 80.6064 85.7793 81.0645 85.7793 81.7617ZM86.4082 86.7383C86.3945 85.3506 87.9531 84.5645 90.5508 84.5645C93.1553 84.5645 94.7139 85.3506 94.7207 86.7383C94.7139 88.1123 93.1553 88.8916 90.5508 88.8848C87.9531 88.8916 86.3945 88.1123 86.4082 86.7383ZM87.6934 86.7383C87.6797 87.4766 88.7324 87.9004 90.5508 87.8867C92.376 87.9004 93.415 87.4766 93.4219 86.7383C93.415 85.9658 92.376 85.5557 90.5508 85.5625C88.7324 85.5557 87.6797 85.9658 87.6934 86.7383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.09766,
    y: 68,
    width: 105.5,
    height: 30.5,
    rx: 15.25,
    stroke: "#818181"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7308_307187",
    x: 0.597656,
    y: 0,
    width: 114.5,
    height: 107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7308_307187"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7308_307187",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadNotCompleted);
export default __webpack_public_path__ + "static/media/uploadNotCompleted.5da508e2f7fe78f0f9e7c6ef70d051ec.svg";
export { ForwardRef as ReactComponent };